<div class="suggestion school-suggestion">
	{{#if moreResults}}
		<div class="suggestion-primary more-suggestions">View all matching schools</div>
	{{else}}
		<div class="school-marker-icon"></div>
		<div class="suggestion-info">
			<div class="suggestion-primary school-name">{{schoolName}}</div>
			<div class="suggestion-secondary school-location">{{address1}}, {{cityName}}, {{stateCode}} {{zip}}</div>
		</div>
	{{/if}}
</div>
